import React, { Component } from 'react';
import classNames from 'classnames';
import './change-term.scss';

class ChangeTerm extends Component {

    render() {

        return (
            <div className={classNames({
                'change-term': true,
                ...this.props.modifiers
            })}>
                <select onChange={this.props.onChange} className="change-term__toggler">
                    {this.props.children}
                </select>
            </div>
        );
    }
};

export default ChangeTerm;